import { createTheme } from '@mui/material/styles';
import { PaletteOptions } from '@mui/material/styles/createPalette';

declare module '@mui/material/styles' {
  interface Palette {
    customColor?: {
      main: string;
      contrastText: string;
    };
  }

  interface PaletteOptions {
    customColor?: {
      main: string;
      contrastText: string;
    };
  }
}

const CustomMUITheme = (primaryColor: string, secondaryColor: string) =>
  createTheme({
    typography: {
      fontSize: 14, // base font size for general text
    },
    palette: {
      primary: {
        main: primaryColor,
        contrastText: '#ffffff',
      },
      secondary: {
        main: secondaryColor,
        contrastText: '#ffffff',
      },
      customColor: {
        main: '#3498db',
        contrastText: '#ffffff',
      },
    } as PaletteOptions,
    components: {
      // Apply 14px font size to form elements
      MuiTextField: {
        defaultProps: {
          size: 'small', // make fields more compact
        },
      },
      MuiInputBase: {
        styleOverrides: {
          input: {
            fontSize: '14px',
          },
        },
      },
      MuiInputLabel: {
        styleOverrides: {
          root: {
            fontSize: '14px',
          },
        },
      },
      MuiFormHelperText: {
        styleOverrides: {
          root: {
            fontSize: '12px',
          },
        },
      },
      MuiFormControlLabel: {
        styleOverrides: {
          root: {
            fontSize: '12px',
          },
          label: {
            fontSize: '14px',
          },
        },
      },     
    }
  });

export default CustomMUITheme;
